import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const loginManagement = createApi({
    reducerPath: "loginManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
    }),
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (body) => ({
                url: "auth/login",
                method: "POST",
                body: body,
            }),
        }),
        forgotPassword: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/users/forgotten-password`,
                method: "POST",
                body: body,
            }),
        }),
        resetPassword: builder.mutation({
            query: ({ body, token }) => {
                return {
                    url: `/v1/${locale}/users/reset-password/${token}`,
                    method: "PATCH",
                    body: body,
                };
            },
        }),
    }),
});

export const { useLoginMutation, useForgotPasswordMutation, useResetPasswordMutation } = loginManagement;
